module.exports = __webpack_public_path__ + "img/email-shape.2e03aa57.svg";